import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"
import { StripeUriRequestValues, StripeUriRequestType } from "types"

export const createStripeUriRequest = createAsyncThunk(
  "stripe-uri-request/create",
  async (values: StripeUriRequestValues) => {
    const response = await API.post("/stripe_uri_requests", values)
    return response.data
  },
)

export const makeStripeUriRequest = (values: StripeUriRequestValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise<StripeUriRequestType>((resolve, reject) => {
      return dispatch(createStripeUriRequest(values))
        .then(
          ({ payload }) => {
            if (!payload || !payload.stripe_uri_request) {
              return reject(payload.error)
            }

            const { redirect_url } = payload.stripe_uri_request

            resolve({ redirect_url })
          },
          () => {
            reject(i18n.t("notice.subscription.session.failure"))
          },
        )
        .catch(() => {
          reject(i18n.t("notice.subscription.session.failure"))
        })
    })
  }
}
